import HTTP from "@/_helpers/http";
import { TRANSACTION__API } from "@/_helpers/urls";
import { TRANSACTION__MUTATIONS } from "../mutation-types";
import { TRANSACTION__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  transactions: [],
  recenttransactions: [],
  traderTransactions: [],
  deposit: [],
  withdraw: [],
  internalTransfer: [],
  depositToAccount: [],
  internaltransferAccount: [],
  customizedDepositToAccounts: [],
  code: null,
  withdrawDetails: {
    client_trading_account_id: null,
    amount: null,
    payment_system_id: null,
  },
  internalTransferDetails: {
    fromAccountID: null,
    toAccountID: null,
    amount: null,
    otpsent: false,
    client_account_id: null,
    trading_account_no: null,
  },
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [TRANSACTION__MUTATIONS.TRANSACTIONHISTORY](state, data) {
    state.transactions = data;
  },
  [TRANSACTION__MUTATIONS.RECENTTRANSACTIONHISTORY](state, data) {
    state.recenttransactions = data;
  },

  [TRANSACTION__MUTATIONS.PAYMENTMETHOD](state, data) {
    state.deposit = data.deposit;
    state.withdraw = data.withdraw;
    state.internalTransfer = data.internalTransfer;
  },

  [TRANSACTION__MUTATIONS.ACCOUNTSTODEPOSIT](state, data) {
    state.customizedDepositToAccounts = data.depositToAccounts;
    state.depositToAccount = data.result;
  },

  [TRANSACTION__MUTATIONS.WITHDRAWDETAILS](state, data) {
    state.withdrawDetails.client_trading_account_id =
      data.client_trading_account_id;
    state.withdrawDetails.amount = data.amount;
    state.withdrawDetails.payment_system_id = data.payment_system_id;
  },

  [TRANSACTION__MUTATIONS.INTERNALTRANSFERACCOUNT](state, data) {
    state.internaltransferAccount = data.result;
  },

  [TRANSACTION__MUTATIONS.INTERNALTRANSFERDETAILS](state, data) {
    state.internalTransferDetails.fromAccountID = data.fromAccountID;
    state.internalTransferDetails.toAccountID = data.toAccountID;
    state.internalTransferDetails.amount = data.amount;
    state.internalTransferDetails.otpsent = data.otpsent;
    state.internalTransferDetails.client_account_id = data.client_account_id;
    state.internalTransferDetails.trading_account_no = data.trading_account_no;
  },

  [TRANSACTION__MUTATIONS.TRADERTRANSACTIONS](state, data) {
    state.traderTransactions = data.allTransactions;
  },
};

// Actions
const actions = {
  async [TRANSACTION__ACTIONS.RECENTTRANSACTIONHISTORY]({ commit, state }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(
        TRANSACTION__API.RECENTTRANSACTIONHISTORY
      );

      if (response.status === 200) {
        commit(TRANSACTION__MUTATIONS.RECENTTRANSACTIONHISTORY, response.data);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  },

  async [TRANSACTION__ACTIONS.TRANSACTIONHISTORY]({ commit, state }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(TRANSACTION__API.TRANSACTIONHISTORY);

      if (response.status === 200) {
        commit(TRANSACTION__MUTATIONS.TRANSACTIONHISTORY, response.data);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  },

  async [TRANSACTION__ACTIONS.PAYMENTMETHOD]({ commit, state }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(TRANSACTION__API.PAYMENTMETHOD);

      commit(TRANSACTION__MUTATIONS.PAYMENTMETHOD, response.data);
      // console.log("response.data", response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [TRANSACTION__ACTIONS.ACCOUNTSTODEPOSIT]({ commit, state }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(TRANSACTION__API.ACCOUNTSTODEPOSIT);

      commit(TRANSACTION__MUTATIONS.ACCOUNTSTODEPOSIT, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  //deposit
  async [TRANSACTION__ACTIONS.CASHDEPOSIT]({ commit, state }, data) {
    try {
      await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(TRANSACTION__API.CASHDEPOSIT, data);
      toast.success("Deposit request sent successfully");
      window.location.reload();
    } catch (error) {
      console.log(error);
      toast.error("Deposit request not sent");
      window.location.reload();
    }
  },

  async [TRANSACTION__ACTIONS.BANKDEPOSIT]({ commit, state }, data) {
    try {
      await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(TRANSACTION__API.BANKDEPOSIT, data);
      toast.success("Deposit request sent successfully");
      window.location.reload();
    } catch (error) {
      console.log(error);
      toast.error("Deposit request not sent");
      window.location.reload();
    }
  },

  async [TRANSACTION__ACTIONS.CARDDEPOSIT]({ commit, state }, data) {
    try {
      await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(TRANSACTION__API.CARDDEPOSIT, data);
      toast.success("Deposit request sent successfully");
    } catch (error) {
      console.log(error);
    }
  },

  // withdraw
  async [TRANSACTION__ACTIONS.SENDCODE]({ commit, state }, data) {
    try {
      await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(TRANSACTION__API.SENDCODE);
      commit(TRANSACTION__MUTATIONS.WITHDRAWDETAILS, data);
      toast.success("OTP has been sent to your email");
    } catch (error) {
      console.log(error);
      toast.error("Failed to send otp");
    }
  },

  async [TRANSACTION__ACTIONS.CASHWITHDRAW]({ commit, state }, data) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(TRANSACTION__API.CASHWITHDRAW, {
        ...data,
      });
      if (response.data.type === "success") {
        toast.success("Withdrawal verification has been sent successfully");
        state.withdrawDetails.client_trading_account_id = null;
        state.withdrawDetails.amount = null;
        state.withdrawDetails.payment_system_id = null;
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
      toast.error("Withdraw verification failed");
      window.location.reload();
    }
  },

  async [TRANSACTION__ACTIONS.BANKWITHDRAW]({ commit, state }, data) {
    try {
      await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(TRANSACTION__API.BANKWITHDRAW, data);
      toast.success("Withdraw request sent successfully");
      window.location.reload();
    } catch (error) {
      console.log(error);
      toast.error("Withdraw request not sent");
      window.location.reload();
    }
  },

  async [TRANSACTION__ACTIONS.CARDWITHDRAW]({ commit, state }, data) {
    try {
      await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(TRANSACTION__API.CARDWITHDRAW, data);
      toast.success("Withdraw request sent successfully");
      window.location.reload();
    } catch (error) {
      console.log(error);
      toast.error("Withdraw request not sent");
      window.location.reload();
    }
  },

  // Internal Transfer
  async [TRANSACTION__ACTIONS.INTERNALTRANSFERACCOUNT]({ commit, state }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(
        TRANSACTION__API.INTERNALTRANSFERACCOUNTS
      );

      commit(TRANSACTION__MUTATIONS.INTERNALTRANSFERACCOUNT, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [TRANSACTION__ACTIONS.INTERNALTRANSFERCODE]({ commit, state }, data) {
    try {
      console.log("data", data);
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(TRANSACTION__API.INTERNALTRANSFERCODE);
      commit(TRANSACTION__MUTATIONS.INTERNALTRANSFERDETAILS, {
        ...data,
        otpsent: response.data.otpsent,
      });
      toast.success("Code has been sent to your email");
    } catch (error) {
      console.log(error);
      toast.error("Failed to send otp");
      state.internalTransferDetails.otpsent = false
    }
  },

  async [TRANSACTION__ACTIONS.CONFIRMINTERNALTRANSFER](
    { commit, state },
    data
  ) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(
        TRANSACTION__API.CONFIRMINTERNALTRANSFER,
        {
          fromAccountID: state.internalTransferDetails.fromAccountID,
          toAccountID: state.internalTransferDetails.toAccountID,
          amount: state.internalTransferDetails.amount,
          code: data.code,
          client_account_id: state.internalTransferDetails.client_account_id,
          trading_account_no: state.internalTransferDetails.trading_account_no,
        }
      );
      if (response.status === 200) {
        toast.success(response.data.message || "Successfully transfered");
        state.internalTransferDetails.fromAccountID = null;
        state.internalTransferDetails.toAccountID = null;
        state.internalTransferDetails.amount = null;
        state.internalTransferDetails.code = null;
        state.internalTransferDetails.client_account_id = null;
        state.internalTransferDetails.trading_account_no = null;
        state.internalTransferDetails.otpsent = false
      }
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error(error.response.data.message || "Failed to send request");
    }
  },

  async [TRANSACTION__ACTIONS.TRADERTRANSACTIONS]({ commit, state }, id) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(
        TRANSACTION__API.TRADERTRANSACTIONS + `/${id}`
      );
      commit(TRANSACTION__MUTATIONS.TRADERTRANSACTIONS, response.data);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
